import React, { useState, useCallback } from 'react';
import { GoalsOverview } from './GoalsOverview';
import { GoalsFixtureDetail } from './GoalsFixtureDetail';
import { GoalsSavedFixtures } from './GoalsSavedFixtures';
import { useFeatureTracking, FeatureNames } from '../../hooks/useActivityTracking';

export type GoalsHubView = 'overview' | 'fixture' | 'saved';

interface GoalsHubProps {
  initialView?: GoalsHubView;
  initialFixtureId?: number | null;
  initialDate?: string | null;
}

export function GoalsHub({
  initialView = 'overview',
  initialFixtureId = null,
  initialDate = null,
}: GoalsHubProps) {
  // Track feature usage
  useFeatureTracking(FeatureNames.GOALS_HUB);
  const [view, setView] = useState<GoalsHubView>(initialView);
  const [selectedFixtureId, setSelectedFixtureId] = useState<number | null>(initialFixtureId);
  const [selectedDate, setSelectedDate] = useState<string | null>(initialDate);

  const handleSelectFixture = useCallback((fixtureId: number) => {
    setSelectedFixtureId(fixtureId);
    setView('fixture');
  }, []);

  const handleBackToOverview = useCallback(() => {
    setView('overview');
    setSelectedFixtureId(null);
  }, []);

  const handleGoToSaved = useCallback(() => {
    setView('saved');
  }, []);

  const handleDateChange = useCallback((date: string) => {
    setSelectedDate(date);
  }, []);

  return (
    <div className="goals-hub">
      {view === 'overview' && (
        <GoalsOverview
          selectedDate={selectedDate}
          onSelectFixture={handleSelectFixture}
          onDateChange={handleDateChange}
          onGoToSaved={handleGoToSaved}
        />
      )}
      {view === 'fixture' && selectedFixtureId && (
        <GoalsFixtureDetail
          fixtureId={selectedFixtureId}
          onBack={handleBackToOverview}
        />
      )}
      {view === 'saved' && (
        <GoalsSavedFixtures
          onSelectFixture={handleSelectFixture}
          onBack={handleBackToOverview}
        />
      )}
    </div>
  );
}

export default GoalsHub;
